import { request } from './request';
import { api_config } from '@/constants/api';
import Utils from '../utils/utils';
let apiUrlV2 = api_config.API_V2_URL;

/**
 * 请求游客token
 * @param {object} 请求参数
 */
const requsetGetAnonymousSessions = () => {
  const options = {
    method: 'POST',
  };
  return new Promise((resolve, reject) => {
    request(apiUrlV2 + 'tmp-sessions', options, true)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 请求用户信息
 * @param {object} 请求参数
 */
const requsetGetProfile = () => {
  const options = {
    method: 'GET',
  };
  return new Promise((resolve, reject) => {
    request(apiUrlV2 + 'accounts/profile', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 请求获取用户订阅信息
 * @param {object} 请求参数
 */
const requsetGetSubscription = (params) => {
  const options = {
    ...params,
    method: 'GET',
  };
  return new Promise((resolve, reject) => {
    request(apiUrlV2 + 'accounts/subscription?from_product=1', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const googleCallback = (params) => {
  const formData = new FormData();
  formData.append('code', params.code);
  formData.append('state', params.state);
  formData.append('refer', `HitPaw_Static_Editor_${Utils.getLanguage()}`);
  const options = {
    method: 'POST',
    body: formData,
  };
  return new Promise((resolve, reject) => {
    request(apiUrlV2 + 'google/callback', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const loginWithToken = (params) => {
  const options = {
    method: 'POST',
    body: params,
  };
  return new Promise((resolve, reject) => {
    request(apiUrlV2 + 'login/with-token', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const checkGoogleSafe = (params) => {
  const formData = new FormData();
  const { email, code, token, id } = params;
  formData.append('email', email);
  formData.append('code', code);
  formData.append('token', token);
  formData.append('id', id);
  const options = {
    method: 'POST',
    body: formData,
  };
  return new Promise((resolve, reject) => {
    request(apiUrlV2 + 'google/check-email', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
/**
 * 请求获取用户订阅信息
 * @param {object} 请求参数
 */
const requsetGetPurchase = (params) => {
  const options = {
    ...params,
    method: 'POST',
  };
  return new Promise((resolve, reject) => {
    request(apiUrlV2 + 'check-out', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 请求获取用户主题信息
 * @param {object} 请求参数
 */
const requsetGetAppearance = (params) => {
  const options = {
    ...params,
    method: 'GET',
  };
  return new Promise((resolve, reject) => {
    request(apiUrlV2 + 'preferences', options)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export {
  requsetGetAnonymousSessions,
  requsetGetProfile,
  requsetGetSubscription,
  requsetGetPurchase,
  requsetGetAppearance,
  googleCallback,
  checkGoogleSafe,
  loginWithToken,
};
